import { Link } from "react-router-dom";
import type { DeskSection } from "../../lib/profile.ts";

export function ShelfFolder({ to, name, line }: DeskSection) {
  return (
    <Link className="home-folder" to={to}>
      <span className="home-folder-name">{name}</span>
      <span className="home-folder-line">{line}</span>
      <span className="home-folder-go">Open the drawer →</span>
    </Link>
  );
}
